import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "fullWidth", "color", "title", "subtitle", "bottomLabel", "error", "deviceSize", "focused", "inputRef", "value", "labelAlign"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { Icon } from '@elements/icon';
import { StyledCheckboxBase, StyledCheckboxLabel, StyledFormControl, StyledFormHelperErrorText, StyledFormHelperText, StyleFromHelperWrapper } from './checkbox-field.styles';
import checkedIcon from '@images/checkbox-checked.svg';
import uncheckedIcon from '@images/checkbox-unchecked.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CheckboxField = function CheckboxField(_ref) {
  var name = _ref.name,
    fullWidth = _ref.fullWidth,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'white' : _ref$color,
    title = _ref.title,
    subtitle = _ref.subtitle,
    bottomLabel = _ref.bottomLabel,
    error = _ref.error,
    deviceSize = _ref.deviceSize,
    focused = _ref.focused,
    inputRef = _ref.inputRef,
    value = _ref.value,
    labelAlign = _ref.labelAlign,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var inputName = name && "".concat(name, "-checkboxfield");
  var isError = !!error;
  var literalProps = {
    htmlFor: inputName,
    id: inputName,
    errorId: inputName && "".concat(inputName, "-error-text")
  };
  return /*#__PURE__*/_jsxs(StyledFormControl, {
    error: isError,
    fullWidth: fullWidth,
    focused: focused,
    children: [/*#__PURE__*/_jsx(StyledCheckboxLabel, {
      labelAlign: labelAlign,
      control: /*#__PURE__*/_jsx(StyledCheckboxBase, _objectSpread(_objectSpread({
        inputProps: {
          type: 'checkbox',
          id: literalProps.id
        },
        error: error || '',
        id: literalProps.id,
        "aria-describedby": inputName,
        name: name,
        fullWidth: fullWidth,
        icon: /*#__PURE__*/_jsx(Icon, {
          src: uncheckedIcon,
          width: 18,
          height: 18
        }),
        checkedIcon: /*#__PURE__*/_jsx(Icon, {
          src: checkedIcon,
          width: 18,
          height: 18
        })
      }, restProps), {}, {
        type: "checkbox"
      })),
      label: /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "body1",
          fontWeight: 500,
          children: title
        }), subtitle && /*#__PURE__*/_jsx(Typography, {
          variant: "caption1",
          color: "abandonedSpaceship",
          children: subtitle
        })]
      })
    }), isError && /*#__PURE__*/_jsx(StyleFromHelperWrapper, {
      children: /*#__PURE__*/_jsx(StyledFormHelperErrorText, {
        id: literalProps.errorId,
        children: error
      })
    }), bottomLabel && !isError ? /*#__PURE__*/_jsx(StyleFromHelperWrapper, {
      children: /*#__PURE__*/_jsx(StyledFormHelperText, {
        $color: color,
        children: bottomLabel
      })
    }) : null]
  });
};
export { CheckboxField };